
import React, { useContext, useRef, useEffect, useState } from 'react'
import { GlobalContext } from '../GlobalContext'
import { useNavigate } from 'react-router-dom'
import Button from '../formfields/Button'
import { useVideo } from '../context/video/VideoContext';
import RedAlert from '../ui-elements/RedAlert'
import { checkIfAssetExists } from '../utils/checkIfAssetExists'
import { getAssetIdFromUrl } from '../utils/getAssetIdFromUrl'
import Modal from '../ui-elements/Modal'
import PhotoInstruction from '../shared-components/PhotoInstruction'
import Card from '../ui-elements/Card'
import { getAnswersForThisAssetId } from '../utils/getAnswersForThisAssetId'
import { subscribe } from '../utils/pubsub'
import { cos } from 'numeric';
import YellowAlert from '../ui-elements/YellowAlert';
import Spinner from '../ui-elements/Spinner';
import GreenAlert from '../ui-elements/GreenAlert';
import { useVoice } from '../context/voice/VoiceContext';
import { tryToInterpretNumber } from '../utils/tryToInterpretNumber';

type Props = {
  questionId?: string
  checklistId?: string
  questionAnswer: string | null | string[]
  setQuestionAnswer: React.Dispatch<React.SetStateAction<any>>
  defaultValue: null | string | string[]
  assetId: string | null
  answerNote: string | null
  setAnswerNote: React.Dispatch<React.SetStateAction<any>>
  answerPhoto: string | null
  setAnswerPhoto: React.Dispatch<React.SetStateAction<any>>
  isAnswerManuallyEdited: boolean
  setIsAnswerManuallyEdited: React.Dispatch<React.SetStateAction<any>>
  jpegString: string | null
  setJpegString: React.Dispatch<React.SetStateAction<any>>
  assetHasDigitalDisplay: boolean | null
  checkPeriodId?: string,
  setFooterButtons: React.Dispatch<React.SetStateAction<string[]>>
  setQuestionAnswerQRProof: React.Dispatch<React.SetStateAction<any>>
  thisQuestion: ObjectStringKeyAnyValue
  footerButtons: string[]
}

function QuestionPhotoAndReading({
  checkPeriodId,
  questionId,
  checklistId,
  questionAnswer,
  setQuestionAnswer,
  defaultValue,
  assetId,
  answerNote,
  setAnswerNote,
  answerPhoto,
  setAnswerPhoto,
  isAnswerManuallyEdited,
  setIsAnswerManuallyEdited,
  jpegString,
  setJpegString,
  assetHasDigitalDisplay,
  setFooterButtons,
  setQuestionAnswerQRProof,
  thisQuestion,
  footerButtons
}: Props) {

  const {
    tableData,
    isVideoMode,
    setIsVideoMode,
    isVideoPlaying,
    setIsVideoPlaying,
    t
  } = useContext(GlobalContext)


  const {
    isRecognizerRunning,
    spokenAnswer
  } = useVoice()

  const navigate = useNavigate()
  const [flowState, setFlowState] = useState<'LookingForQR' | 'QRFound' | 'PhotoTaken'>('LookingForQR')
  const [AIReadingState, setAIReadingState] = useState<'idle' | 'reading' | 'error'>('idle')
  // last ai result is an object which has keys 'error' 'temperature_found' and 'temperature_reading'

  const [LastAIResult, setLastAIResult] = useState<{ error?: string, temperature_found?: boolean, temperature_reading?: number } | null>(null)
  const [showReadingDetectedModal, setShowReadingDetectedModal] = useState(false)
  const [showInvalidAssetMessage, setShowInvalidAssetMessage] = useState(false)
  const [showUnexpectedQrCodeModal, setShowUnexpectedQrCodeModal] = useState(false)
  const [showAssetAlreadyChecked, setShowAssetAlreadyChecked] = useState<string | null>(null)
  const [showFoundBanner, setShowFoundBanner] = useState(false)
  const [initialAnnouncementDone, setInitialAnnouncementDone] = useState(false)
  const { requestBackendAPIReading } = useContext(GlobalContext)
  const { QRCodesPresent, setQRCodesSearchOptions, captureAsJPEGString, setExpectedReadingDetails, aiResults, requestRawAiReading } = useVideo()
  const defaultQrSearchOptions = {
    'enabled': true,
    'expectedDomains': ['QRWL.ME', 'CHQN.IN'],
    'searchArea': { top: 0, left: 0, width: 1, height: 1 },
    'showSearchArea': false
  }

 
  useEffect(() => {
    if (QRCodesPresent && QRCodesPresent.length > 0) {
      console.log('✅ QRCodesPresent', QRCodesPresent)
      const assetIdFromQRCode = getAssetIdFromUrl(QRCodesPresent[0])
      if (flowState == 'LookingForQR' && assetIdFromQRCode === assetId) {
        if(isRecognizerRunning){
          console.log("Recognizer running, speaking")
        } else {
          console.log("Recognizer not running, not speaking")
        }
        setFlowState('QRFound')
        setShowFoundBanner(true)
        setTimeout(() => {
          console.log("Hiding banner")
          setShowFoundBanner(false)
        }
          , 4000)
        const qrPhotoData = captureAsJPEGString(600) || ''
        setQuestionAnswerQRProof(qrPhotoData)
      }
    }
  }, [QRCodesPresent, flowState, assetId])

  useEffect(() => {
    if (flowState == 'QRFound' && jpegString) {
      setFlowState('PhotoTaken')
    }
    if (flowState == 'PhotoTaken' && jpegString == null) {
      setFlowState('QRFound')
    }
  }, [jpegString, flowState])



  useEffect(() => {
    if (flowState == 'QRFound') {
      setFooterButtons(['takePhoto', 'back'])
    }
    else if (flowState == 'PhotoTaken') {
      if (questionAnswer && questionAnswer != '') {
        setFooterButtons(['save', 'saveWithNote', 'retakePhoto', 'back'])
      } else {
        setFooterButtons(['retakePhoto', 'back'])
      }
    }
    else {

        if (thisQuestion && thisQuestion.isAnswerRequired === false){
          setFooterButtons([...footerButtons, 'skip'])
        }
    }
  }, [flowState, questionAnswer]
  )


  useEffect(() => {
    return () => {
      // code to run when the user navigates away from the page
      console.log("Stopping camera (5)")
      setIsVideoMode(false)
      setIsVideoPlaying(false)
      setJpegString(null)
      setAnswerNote(null)
      // console.log("leaving page")
    }
  }, [])

  useEffect(() => {
    if (showAssetAlreadyChecked) {
      const timeoutId = setTimeout(() => {
        setShowAssetAlreadyChecked(null)
      }, 2000)
      return () => {
        clearTimeout(timeoutId)
      }
    }
  }, [showAssetAlreadyChecked])


  useEffect(() => {
    if (assetId && tableData) {
      // check if asset exists
      if (tableData && tableData['Assets'] && tableData['Assets'][assetId]) {
        const asset = tableData['Assets'][assetId]
        if (asset['DigitsAfterDecimal'] && asset['DigitsAfterDecimal']) {
          console.log(`setting expected reading details. Before: ${asset["DigitsBeforeDecimal"]} after: ${asset["DigitsAfterDecimal"]}`)
          setExpectedReadingDetails(parseInt(asset['DigitsAfterDecimal']), 10)
        } else {
          console.log(`No expected reading details found for asset ${assetId}`)
        }
      }
    }
  }, [assetId, tableData])

   useEffect(() => {
    if (isRecognizerRunning && flowState === 'LookingForQR' && !initialAnnouncementDone) {
        if (assetId && tableData && tableData['Assets'] && tableData['Assets'][assetId]) {
        const asset = tableData['Assets'][assetId]
        const assetName = asset['AssetName']
        if(assetName){
          setInitialAnnouncementDone(true)  
        } 
      }
    }
  }, [isRecognizerRunning, assetId, tableData, initialAnnouncementDone])


  // try ai reading when the photo of the asset is taken
  useEffect(() => {
    if (jpegString && flowState === 'PhotoTaken') {

      const requestId = `${checkPeriodId}-${questionId}-${assetId}-${Date.now()}`
      setAIReadingState('reading')
      const unsubscribe = subscribe("returnAiReadingResult", data => {
        if (data.request_id === requestId) {
          setLastAIResult(data.result)
          if (data.result && data.result.temperature_found && data.result.temperature_reading) {
            setQuestionAnswer(`${data.result.temperature_reading}`)
          }


          if (data.result && data.result.error) {
            setAIReadingState('error')
          } else {
            setAIReadingState('idle')
          }
          unsubscribe()

        } else {
          console.log("AI reading result received for a different request", data.request_id, requestId)
        }
      })
      let hints = null
      if(thisQuestion && thisQuestion.AIHints){
        hints = thisQuestion.AIHints
      }
      console.log("Requesting AI reading with hints:", hints) 
      requestBackendAPIReading(jpegString, requestId, hints)
    }
  }, [jpegString, flowState])


  useEffect(() => {
    setIsVideoMode(true)
    setIsVideoPlaying(true)
    setFlowState('LookingForQR')
  }, [questionId])


    
  useEffect(() => {
    // this handles unrecongised qr codes and directing to qr codes for other assets in the checklist
    let isAssetIdValid = false
    let doesAssetMatch = null
    let letHasQrBeenFound = false
    let assetIdFromDataUrl = null
    setQRCodesSearchOptions(defaultQrSearchOptions)

    if (assetId && tableData && tableData.Assets) {
      // check if asset exists
      if (tableData && checkIfAssetExists(assetId, tableData)) {
        isAssetIdValid = true
      }
      // check if asset from QR code matches asset associated with this question
      if (QRCodesPresent && QRCodesPresent.length > 0) {
        assetIdFromDataUrl = getAssetIdFromUrl(QRCodesPresent[0])
        letHasQrBeenFound = true
        doesAssetMatch = assetIdFromDataUrl === assetId
//        console.log(`Asset from QR code: ${assetIdFromDataUrl} asset from question: ${assetId} does asset match? ${doesAssetMatch}`)

      } else {
        letHasQrBeenFound = false
        doesAssetMatch = false
      }


      if (isAssetIdValid) {
        //console.log(`has qr been found: ${letHasQrBeenFound} does asset match: ${doesAssetMatch}`)


        if (letHasQrBeenFound && doesAssetMatch === false) {

          const assetIds: ObjectStringKeyAnyValue = getAnswersForThisAssetId(tableData, checkPeriodId)
          const answerForScannedAsset = assetIds && assetIds[assetIdFromDataUrl]

          if (answerForScannedAsset && answerForScannedAsset.answerId) {
            if (answerForScannedAsset['pending'] === true) {
              // if it an asset that hasn't been checked yet,
              // redirect to that question
              navigate(`/checklists/${checkPeriodId}/${answerForScannedAsset.answerId}`)
            } else {
              // if it an asset that has been checked already
              setShowAssetAlreadyChecked(assetIdFromDataUrl)
              setShowUnexpectedQrCodeModal(false)
            }
          } else {
            // if it not part of this checklist at all, show a warning
            setShowUnexpectedQrCodeModal(true)
            setShowAssetAlreadyChecked(null)
          }

        }

      } else {
        // if asset is invalid, show warning message
        setShowInvalidAssetMessage(true)
        console.log("Stopping camera (4)")
        // setIsVideoMode(false)
        // setIsVideoPlaying(false)
      }
    } else {
      setShowInvalidAssetMessage(false)
    }

  }, [QRCodesPresent, tableData, assetId])


  //console.log(flowState)

  // update the answer from voice commands if voice recognition is running
  useEffect(() => {
    if (isRecognizerRunning) {
      if (flowState === 'PhotoTaken' && isRecognizerRunning) {
          const interpretedNumber = tryToInterpretNumber(spokenAnswer);
          if (interpretedNumber && interpretedNumber != '') {
            console.log(`Interpreted number from spoken answer: "${spokenAnswer}" -> "${interpretedNumber}"`);
            setQuestionAnswer(interpretedNumber);
          } else {
            console.log(`Could not interpret a number from spoken answer: "${spokenAnswer}"`);
          }
      }
    }
  },[spokenAnswer, isRecognizerRunning])

  return <div
    className={`max-w-3xl w-full h-full pt-0 pb-8 px-3 flex flex-col gap-2 justify-center  items-center`}
  >
    {flowState == 'LookingForQR' &&
      <>
        <PhotoInstruction>
          <h1>{t('QuestionPages.QuestionPhotoAndReading.scanQrCode')}</h1>
        </PhotoInstruction>
      </>
    }







    {!assetId && <RedAlert fullwidth={true}>{t('QuestionPages.QuestionPhotoAndReading.noAssetId')}</RedAlert>}
    {showInvalidAssetMessage && <RedAlert fullwidth={true}>{t('QuestionPages.QuestionPhotoAndReading.invalidAssetId', { assetId })}</RedAlert>}




    {showAssetAlreadyChecked && <Modal>
      <div className={`flex flex-col gap-4`}>
        <div className={`flex flex-col gap-2 items-center`}>

          <img src={`/icons/green-tick-icon.png`} alt={'Green tick icon'} className={`w-8 h-8`} />
          <h4 className={`font-righteous text-xl text-brandblue`}>{t('QuestionPages.QuestionPhotoAndReading.assetAlreadyChecked', { assetId: showAssetAlreadyChecked })}</h4>
        </div>
        <Button
          text={'Ok'}
          onClick={() => setShowAssetAlreadyChecked(null)}
          size={'big'}
          fullwidth={true}
          variant={'primary'}
        />
      </div>
    </Modal>}


    {showUnexpectedQrCodeModal && <Modal>
      <div className={`flex flex-col gap-4`}>
        <div className={`flex flex-col gap-2`}>
          <h4 className={`font-righteous text-xl text-brandblue`}>{t('QuestionPages.QuestionPhotoAndReading.unexpectedQrCode')}</h4>
          {assetId && <p>{t('QuestionPages.QuestionPhotoAndReading.expectingQrCode', { assetId })}</p>}
        </div>
        <Button
          text={'Retry'}
          onClick={() => setShowUnexpectedQrCodeModal(false)}
          size={'big'}
          fullwidth={true}
          variant={'primary'}
        />
      </div>
    </Modal>}



    {flowState && flowState == 'PhotoTaken' && <Card>
      <div className={`w-full flex flex-col gap-2 items-center`}>
        {jpegString && <img src={jpegString} alt={'Photo taken'} style={{ maxHeight: '40vh' }} className={``} />}
        <input
          className={`text-left font-righteous text-brandblue text-3xl bg-white text-center drop-shadow-lg border border-gray-300 rounded hover:opacity-90-lg focus:ring-blue-500 focus:border-blue-500 block w-full px-5 py-3`}
          onChange={(e) => {
            setQuestionAnswer(e.target.value)
            setIsAnswerManuallyEdited(true)
          }}
          type={'text'}
          inputMode={/iPhone|iPad|iPod/.test(navigator.userAgent) ? 'text' : `numeric`} // the pattern below means 0 to 9, minus signs and a decimal point
          pattern={"^-?\d*(\.\d+)?$"}
          value={questionAnswer || ''}
          placeholder='Enter reading here'
        />
        {AIReadingState === 'reading' && 
        <Spinner alignment='center' size={'small'}><p className={`text-xs py-1`}>{t('QuestionPages.QuestionPhotoAndReading.aiReadingInProgress')}</p></Spinner>}

        {AIReadingState === 'idle' && LastAIResult && LastAIResult.temperature_found && LastAIResult.temperature_reading && 
        <GreenAlert size='small' alignment='center' fullwidth={true}>{t('QuestionPages.QuestionPhotoAndReading.aiSuggestedAnswer', { temperature: LastAIResult.temperature_reading })}</GreenAlert>}

        {AIReadingState === 'error' && 
        <YellowAlert size='small' alignment='center' fullwidth={true}>{t('QuestionPages.QuestionPhotoAndReading.aiError')}<br></br>{LastAIResult && LastAIResult.error}</YellowAlert>}

      </div>
    </Card>}

    {showFoundBanner && <>


      <PhotoInstruction >{t('QuestionPages.QuestionPhotoAndReading.qrCodeFound')}</PhotoInstruction>

    </>}



  </div>
}
export default QuestionPhotoAndReading